import React, { useEffect } from 'react';
import { translate } from '../Services/translation';
import MiniCartProduct from './MiniCartProduct';
import { datalayerViewCart } from '../Services/Gtm.service';
import { useSelector } from 'react-redux';

const MiniCart = ({
  includeVat,
  quantity,
  orderRows,
  orderTotal,
  checkoutUrl,
  showInfo,
  toggle,
  update,
}) => {
  const cart = useSelector((state) => state.cart);
  const { gtmViewModel } = cart;
  const { ecommerce } = gtmViewModel;

  const onCartClick = () => {
    toggle();
    if (orderRows?.length > 0) {
      datalayerViewCart(ecommerce);
    }
  };

  return (
    <>
      <div
        className={!showInfo ? 'overlay' : 'overlay overlay--show'}
        onClick={() => onCartClick()}
      ></div>
      <a onClick={() => onCartClick()}>
        <i className="cart--icon">
          <span className="cart__quantity">{quantity}</span>
        </i>
        <span className="caption-1">{translate('minicart.checkout')}</span>
      </a>
      <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
        <div className="cart__info-container">
          <div className="cart__header">
            <h2>{translate('minicart.title')}</h2>
            <a onClick={() => toggle()}>{translate('minicart.close')}</a>
          </div>
          <div className="mini-cart-wrap__scroll">
            {orderRows.map((orderRow) => {
              const { rowSystemId, quantity, size, packageQuantity } = orderRow;
              return (
                <MiniCartProduct
                  key={rowSystemId}
                  product={orderRow}
                  articleNumber={orderRow.articleNumber}
                  includeVat={includeVat}
                  onCartItemIncrement={() =>
                    update(orderRow.articleNumber, quantity + packageQuantity)
                  }
                  onCartItemDecrement={() =>
                    update(orderRow.articleNumber, quantity - packageQuantity)
                  }
                  onCartItemRemove={() => update(orderRow.articleNumber, 0)}
                />
              );
            })}
          </div>
          <div className="cart__summary-section">
            <div className="cart__summary-section--total-amount">
              {orderRows.length > 0 ? (
                <>
                  <b>{translate('minicart.total')}</b>
                  <div className="cart__summary-section--price-vat">
                    <span>{orderTotal}</span>
                    <span>
                      {includeVat
                        ? translate('minicart.inclvat')
                        : translate('minicart.exclvat')}
                    </span>
                  </div>
                </>
              ) : (
                <span>{translate('checkout.cart.empty')}</span>
              )}
            </div>
            {orderRows.length > 0 ? (
              <a href={checkoutUrl} className="cart__checkout-button">
                {translate('minicart.checkout')}
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default MiniCart;
